import React, { Fragment } from "react";
import { Container, Row, Col } from "reactstrap";
import { version } from "../../package.json";

const Footer = () => (
  <Fragment>
    <Row className="m-0 p-0">
      <Col className="text-center text-muted">
        <small>v{version}</small>
      </Col>
    </Row>

    <footer className="footer">
      <Container fluid>
        <Row className="text-muted">
          <Col xs="6" className="text-left">
            <ul className="list-inline">
              <li className="list-inline-item">
                <a
                  href="https://www.messagebroadcast.com/contact"
                  target="_blanl"
                  className="text-muted"
                  rel="noopener noreferrer"
                >
                  Support
                </a>
              </li>

              <li className="list-inline-item">
                <a
                  href="https://www.messagebroadcast.com/privacy-policy"
                  target="_blank"
                  className="text-muted"
                  rel="noopener noreferrer"
                >
                  Privacy
                </a>
              </li>

              <li className="list-inline-item">
                <span className="text-muted" href="#">
                  Terms of Service
                </span>
              </li>
            </ul>
          </Col>
          <Col xs="6" className="text-right">
            <p className="mb-0">
              &copy; {new Date().getFullYear()} -{" "}
              <a
                href="https://www.messagebroadcast.com/"
                target="_blank"
                className="text-muted"
                rel="noopener noreferrer"
              >
                Message Broadcast
              </a>
              , LLC. All rights reserved.
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  </Fragment>
);

export default Footer;
